// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('calculationOverview', {
//         templateUrl: 'views/components/views/calculationOverview/calculationOverview.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'calculationOverviewService', 'ttGridFactory', function ($stateParams, calculationOverviewService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let calculationSeasonYearKeyno = $stateParams.calculationseasonyear_keyno;

//             vm.model = {
//                 gridReady: false
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: 'w_calculationoverview',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             }).setCustomToolbarButtons([{
//                 name: 'recalculate',
//                 text: 'recalculate',
//                 func: () => prepareRecalculation(),
//                 icon: 'fa-calculator',
//                 cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                 translate: true,
//                 disabled: function () { return hasDirty(); }
//             }]);
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 vm.grid.dataTask.loadData = {
//                     method: 2256,
//                     parameters: { calculationseasonyear_keyno: calculationSeasonYearKeyno }
//                 };

//                 vm.model.gridReady = true;

//                 if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region TOOLBAR BUTTON VALIDATION

//             function getIsSelectedItems() {
//                 let dirtyItems = vm.grid.gridfunc?.getDirtyRows() || [];
//                 let isSelectedItems = [];

//                 dirtyItems.forEach((item) => {
//                     if (item && (item.is_selected === true || item.is_selected === '1')) isSelectedItems.push(item);
//                 });

//                 return isSelectedItems;
//             }

//             function hasDirty() {
//                 let parmItems = getIsSelectedItems();

//                 if (parmItems.length > 0) return false;

//                 return true;
//             }

//             // #endregion TOOLBAR BUTTON VALIDATION

//             // #region TOOLBAR BUTTON FUNCTIONS

//             function prepareRecalculation() {
//                 let items = getIsSelectedItems();
//                 let promises = [];

//                 vm.grid.gridfunc.gridProgress(true);

//                 for (let i = 0; i < items.length; i++) {
//                     promises.push(calculationOverviewService.recalculateGrid({ calculationhead_keyno: items[i].calculationhead_keyno }));
//                 }

//                 Promise.all(promises).then((response) => {
//                     vm.grid.gridfunc.gridProgress(false);
//                     vm.grid.gridfunc.rebind();
//                     Promise.resolve(response);
//                 }, (error) => Promise.reject(error));

//                 return Promise.promise;
//             }

//             // #endregion TOOLBAR BUTTON FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
